import React from 'react';
import PageHeader from './PageHeader';
import { Grid } from '@mui/material';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import Results from './Results';

class Clients extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      loading: true,
      predmet: []
    }
  }

  componentDidMount() {
    this.setState({predmet: this.props.predmet})
    this.renderClientsPredmet();
  }

  renderClientsPredmet = () => {
    window.makeRequest("GET", `/api/getClients`, null, true, (callback) => {
      this.setState({clients2: callback.body});
    }, (err) => {
      console.log('err', err);
    });

  }

  DeleteClientsPredmet = (id) => {
    this.props.deleteClient(id);
  }




  render() {
    
    return (
      <>
        <PageTitleWrapper >
          {this.props.predmet.user_write === true &&<PageHeader reloadClients={this.props.renderClients}  predmetID={this.props.predmet.ID} clients={this.props.clients} users={this.state.clients2}  />}
        </PageTitleWrapper>
        <Grid
          sx={{ px: 0 }}
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} mt={-2}>
            <Results delete={(e)=> this.DeleteClientsPredmet(e)} predmet={this.state.predmet} clients={this.props.clients} />
          </Grid>
        </Grid>
      </>
    );
  }
  
}

export default Clients;
